import React from 'react'
import GenericTitleP from '../../titles/GenericTitleP'
import { Col, Row } from 'react-bootstrap'
import UserCreator from './groupCreator/UserCreator'
import CreatedGroup from './createdGroup/CreatedGroup'

const UserGroupSelector = () => {
  return (
    <div>
      <GenericTitleP>Create A User Group for Email List</GenericTitleP>
      <Row style={{paddingBottom:"60px"}}>
        <Col sm={12} md={6}>
          <UserCreator />
        </Col>
        <Col sm={12} md={6}>
          <CreatedGroup />
        </Col>
      </Row>
    </div>
  )
}

export default UserGroupSelector